/* src/app/shared/components/add-new-company-dialog/existing-company-warning/existing-company-warning.component.scss */
::-webkit-scrollbar {
  width: 7px;
  height: 7px;
}
::-webkit-scrollbar-thumb {
  background: #acacac;
  border-radius: 8px;
}
::-webkit-scrollbar-track {
}
body {
  scrollbar-face-color: #acacac;
  scrollbar-track-color: rgb(213.5, 213.5, 213.5);
}
:host {
  display: block;
}
:host .alert-container {
  display: flex;
  align-items: center;
  background-color: #fffcf0;
  border: 1px solid #ffc107;
  border-left: 6px solid #ffc107;
  border-radius: 6px;
  padding: 16px;
  font-family:
    "Inter",
    Arial,
    sans-serif,
    sans-serif;
}
:host .alert-content {
  display: flex;
  align-items: center;
}
:host .alert-text-container {
  color: rgb(137, 84, 0);
}
:host .alert-title {
  font-weight: 600;
  margin-bottom: 4px;
}
:host .alert-description {
  font-size: 14px;
  display: flex;
  align-items: center;
}
:host .alert-icon {
  font-size: 20px;
  margin-right: 14px;
  vertical-align: middle;
  width: 35px;
  color: rgb(137, 84, 0);
}
:host .alert-link {
  color: #0077cc;
  font-weight: 600;
  text-decoration: none;
  margin-left: 4px;
}
:host .alert-button {
  white-space: nowrap;
  font-weight: 600;
  font-size: 12px;
  color: #000;
  background: rgb(255, 182, 0) !important;
  width: 160px;
  margin-left: 16px;
}
:host .alert-button mat-icon {
  margin-right: 4px;
}
/*# sourceMappingURL=existing-company-warning.component.css.map */
